// eslint-disable-next-line no-restricted-imports
import { PostHogProvider as PostHogSDKProvider } from 'posthog-js/react';
import { type ReactNode } from 'react';

import { isDefined } from 'common';

import { staffPostHogOptions } from './options';

// Since the deploy script isn't run locally, we need to hardcode here to connect to dev
const DEV_POSTHOG_KEY = 'phc_gtEkpiKk98dZymmUrj0JnxbbwzHmAZvlhgxHUMYoGKj';
const POSTHOG_KEY =
  import.meta.env.MODE === 'development' ? DEV_POSTHOG_KEY : import.meta.env.VITE_POSTHOG_KEY;

interface PostHogProviderProps {
  children: ReactNode;
}

export function PostHogProvider(props: PostHogProviderProps) {
  // TODO: do not initialize provider if in CI environment
  if (!isDefined(POSTHOG_KEY)) {
    console.warn('PostHog disabled: missing VITE_POSTHOG_KEY');
    return props.children;
  }
  return (
    <PostHogSDKProvider apiKey={POSTHOG_KEY} options={staffPostHogOptions}>
      {props.children}
    </PostHogSDKProvider>
  );
}
